var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffeeMug = function SvgCoffeeMug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#coffee-mug_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M5.543 15.543a4.29 4.29 0 0 1 3.029-1.257h14.286a4.29 4.29 0 0 1 4.082 2.983h.203a9.286 9.286 0 1 1 0 18.571h-.651A7.14 7.14 0 0 1 20 40H11.43a7.14 7.14 0 0 1-7.143-7.142V18.572c0-1.137.452-2.229 1.257-3.029m21.6 16.012a5 5 0 0 0 0-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M13.572 2.209a2.143 2.143 0 1 0-4.286 0v5.714a2.143 2.143 0 0 0 4.286 0zm8.571 0a2.143 2.143 0 0 0-4.285 0v5.714a2.143 2.143 0 1 0 4.285 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coffee-mug_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgCoffeeMug;